<h2>Réinitialiser votre mot de passe</h2>
<form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" class="account-section">
  <div class="form-group">
    <label for="password"></label>
    <input
      id="password"
      type="password"
      formControlName="password"
      placeholder="Nouveau Mot de passe"
      [ngClass]="{ 'is-invalid': isSubmitted && password.invalid }" />

    @if (isSubmitted && password.invalid) {
      <div class="error-msg">
        @if (password.errors?.['required']) {
          <span>Mot de passe requis</span>
        }
        @if (password.errors?.['minlength']) {
          <span>Le mot de passe doit contenir au moins {{ password.errors?.['minlength'].requiredLength }} caractères.</span>
        }
        @if (password.errors?.['pattern']) {
          <span>Le mot de passe doit contenir au moins une majuscule, une minuscule, un chiffre et un caractère spécial.</span>
        }
      </div>
    }
  </div>

  <div class="form-group">
    <label for="confirmPassword"></label>
    <input
      id="confirmPassword"
      type="password"
      formControlName="confirmPassword"
      placeholder="Confirmer votre Mot de passe"
      [ngClass]="{ 'is-invalid': isSubmitted && confirmPassword.invalid }" />

    @if (isSubmitted && confirmPassword.invalid) {
      <div class="error-msg">
        @if (confirmPassword.errors?.['required']) {
          <span>Confirmation requise</span>
        }
        @if (passwordMismatch) {
          <span>Les mots de passe ne correspondent pas</span>
        }
      </div>
    }
  </div>

  <button type="submit" class="button-component" [disabled]="loading">Mettre à jour le mot de passe</button>
</form>
